import { Layout } from './layout';

Layout.displayName = 'Caption';

export { Layout as Caption };

export type { Props as CaptionProps } from './types';
